
export default {
  data() {
    return {
      selectedTab: 0,
      plans: [
        {
          name: "general",
          title: "عمومی",
          child: [
            {
              name: "سپیدار",
              cpu: "4",
              ram: "4",
              disk: "50",
              price: "814,720",
              icon: "poplar.svg",
              alt: "طرح سپیدار خرید سرور ابری",
              title: "ٓطرح سپیدار خرید سرور ابری",
            },
            {
              name: "کاج",
              cpu: "4",
              ram: "8",
              disk: "100",
              price: "1,221,491",
              icon: "pine.svg",
              alt: "طرح کاج خرید سرور ابری",
              title: "ٓطرح کاج خرید سرور ابری",
            },
            {
              name: "سرو",
              cpu: "8",
              ram: "8",
              disk: "100",
              price: "1,497,143",
              icon: "cedar.svg",
              alt: "طرح سرو خرید سرور ابری",
              title: "طرح سرو خرید سرور ابری",
            },
            {
              name: "بید",
              cpu: "16",
              ram: "8",
              disk: "100",
              price: "2,017,819",
              icon: "Willow.svg",
              alt: "طرح بید خرید سرور ابری",
              title: "طرح بید خرید سرور ابری",
            },
            {
              name: "افرا",
              cpu: "16",
              ram: "16",
              disk: "200",
              price: "2,810,442",
              icon: "Maple.svg",
              alt: "طرح افرا خرید سرور ابری",
              title: "طرح افرا خرید سرور ابری",
            },
            {
              name: "راش",
              cpu: "16",
              ram: "32",
              disk: "400",
              price: "4,266,450",
              icon: "beech.svg",
              alt: "طرح راش خرید سرور ابری",
              title: "طرح راش خرید سرور ابری",
            },
          ],
        },
        // {
        //   name: "storage",
        //   title: "ذخیره سازی",
        //   child: [
        //     {
        //       name: "g2-big",
        //       cpu: "1",
        //       ram: "1",
        //       disk: "25",
        //       price: "1,510,000",
        //     },
        //     {
        //       name: "g2-big",
        //       cpu: "1",
        //       ram: "1",
        //       disk: "25",
        //       price: "1,510,000",
        //     },
        //     {
        //       name: "g2-big",
        //       cpu: "1",
        //       ram: "1",
        //       disk: "25",
        //       price: "1,510,000",
        //     },
        //     {
        //       name: "g2-big",
        //       cpu: "1",
        //       ram: "1",
        //       disk: "25",
        //       price: "1,510,000",
        //     },
        //   ],
        // },
      ],
    };
  },
};
